import React from 'react';

// Importing all sections used in the homepage
import { Home, About, Counter, Testimonials, Blogs, Services, NewsletterSection, Features, Team, Banner, WhyChooseUs, Clients, Process, PortfolioSection, Products, Menu, HomeBooking } from '../../sections';


const HomePage = () => {

  return (
    <div className='homepage'>
      <Home /> {/* Home Section */}
      <HomeBooking /> {/* Table Booking Form */}
      <Features /> {/* Features Section */}
      <About /> {/* About Section */}
      <Menu /> {/* Menu Section */}
      <Services /> {/* Services Slider */}
      <WhyChooseUs /> {/* Why Choose Us section */}
      <Products /> {/* Popular Products */}
      <Counter /> {/* Counter Section */}
      <Process /> {/* Process section */}
      <Banner /> {/* Banner Section */}
      <PortfolioSection /> {/* Portfolio Section */}
      <Testimonials /> {/* Testimonials Slider */}
      <Team /> {/* Team section */}
      <NewsletterSection /> {/* Newsletter subscription Section */}
      <Blogs /> {/* Latest blog posts */}
      <Clients /> {/* Clients Slider */}
    </div>
  )

}

export default HomePage;